"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOTSTRAP_URL = exports.ENV_PATTERNS = exports.ENTRY_ASSETS_FILE = exports.HOSTS_CONFIG_FILE = exports.REMOTES_CONFIG_FILE = exports.DIST_CONFIG_FILE = exports.REMOTE_ENTRY_FILE = exports.GLOBAL_DIRECTORY = exports.CDN_PREFIX_PATH = exports.CDN_CONFIG = exports.GSHA_FILE = exports.CONFIG_DIRECTORY = exports.APP_TARGETS_BY_NAMESPACE = exports.APP_TARGETS = exports.APP_FOLDERS = void 0;
function deepFreeze(object) {
    Object.getOwnPropertyNames(object).forEach(function (name) {
        var value = object[name];
        if (value && typeof value === 'object') {
            deepFreeze(value);
        }
    });
    return Object.freeze(object);
}
function initAppTarget(baseFolder) {
    var pattern = "^".concat(baseFolder).concat(BASE_APP_MATCH).concat(DIST_CONFIG_FILE.replace('.', '.'));
    return { baseFolder: baseFolder, configPattern: new RegExp(pattern) };
}
var CONFIG_DIRECTORY = '_config';
exports.CONFIG_DIRECTORY = CONFIG_DIRECTORY;
var GLOBAL_DIRECTORY = '_global';
exports.GLOBAL_DIRECTORY = GLOBAL_DIRECTORY;
var CDN_PREFIX_PATH = '/web';
exports.CDN_PREFIX_PATH = CDN_PREFIX_PATH;
var REMOTES_CONFIG_FILE = 'remotes.json';
exports.REMOTES_CONFIG_FILE = REMOTES_CONFIG_FILE;
var HOSTS_CONFIG_FILE = 'hosts.json';
exports.HOSTS_CONFIG_FILE = HOSTS_CONFIG_FILE;
var DIST_CONFIG_FILE = 'config.json';
exports.DIST_CONFIG_FILE = DIST_CONFIG_FILE;
var REMOTE_ENTRY_FILE = 'remoteEntry.js';
exports.REMOTE_ENTRY_FILE = REMOTE_ENTRY_FILE;
var GSHA_FILE = 'gsha';
exports.GSHA_FILE = GSHA_FILE;
var BOOTSTRAP_FILE = 'bootstrap.js';
var ENTRY_ASSETS_FILE = 'entry-assets.json';
exports.ENTRY_ASSETS_FILE = ENTRY_ASSETS_FILE;
var APP_FOLDERS = Object.freeze(['apps', 'internal-apps', 'mfe', 'web-internal-mfe']);
exports.APP_FOLDERS = APP_FOLDERS;
var BASE_APP_MATCH = '/([0-9a-zA-Z_-]+)/[0-9a-f]{7}/';
var CDN_CONFIG = deepFreeze({
    dev: {
        host: 'https://dev.cloverstatic.com',
        envPattern: /^https:\/\/.*.dev.clover.com$/,
    },
    prod: {
        host: 'https://cloverstatic.com',
        envPattern: /^https:\/\/www(\.eu\.|\.la\.|\.)clover\.com$/,
    },
});
exports.CDN_CONFIG = CDN_CONFIG;
var APP_TARGETS = deepFreeze(APP_FOLDERS.reduce(function (targets, folder) {
    targets[folder] = initAppTarget(folder);
    return targets;
}, {}));
exports.APP_TARGETS = APP_TARGETS;
var APP_TARGETS_BY_NAMESPACE = {
    standard: APP_TARGETS['mfe'],
    internal: APP_TARGETS['web-internal-mfe'],
};
exports.APP_TARGETS_BY_NAMESPACE = APP_TARGETS_BY_NAMESPACE;
var ENV_PATTERNS = {
    DEV_LOCAL: /^(localhost|localhost:[0-9]{2,4}|.*\.netlify\.app)$/,
    DEV_PREVIEW: /^(.*\.netlify\.app)$/,
};
exports.ENV_PATTERNS = ENV_PATTERNS;
var BOOTSTRAP_URL = "".concat(CDN_CONFIG.prod.host).concat(CDN_PREFIX_PATH, "/").concat(GLOBAL_DIRECTORY, "/").concat(BOOTSTRAP_FILE);
exports.BOOTSTRAP_URL = BOOTSTRAP_URL;
//# sourceMappingURL=contants.js.map